import Tag from "../tag/tag.component";

interface CNoteProps {
  // Pill label, e.g. "General cashback model".
  tag: string;
  // Optional fine print beside it.
  fine?: string;
}

// A labelled caveat line above a how-it-works block (the preview's
// `.c-note`), making clear the steps describe a general model.
const CNote = ({ tag, fine }: CNoteProps) => (
  <div className="mb-7 flex flex-wrap items-center gap-3">
    <Tag>{tag}</Tag>
    {fine && <span className="text-sm text-ink-muted">{fine}</span>}
  </div>
);

export default CNote;
